// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__mTKE_","label":"styles_label__1joum","icon":"styles_icon__sx9lm"};